import React from 'react';
import { MessageCircleIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { WA_URL } from './constants';
export function WhatsAppButton() {
  return <motion.a href={WA_URL} target="_blank" rel="noopener noreferrer" className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-16 h-16 bg-[#25D366] text-white rounded-full shadow-2xl hover:bg-[#20bd5a] transition-colors duration-300" initial={{
    scale: 0,
    opacity: 0
  }} animate={{
    scale: 1,
    opacity: 1
  }} transition={{
    type: 'spring',
    stiffness: 260,
    damping: 20,
    delay: 1
  }} whileHover={{
    scale: 1.1
  }} whileTap={{
    scale: 0.9
  }} aria-label="Contactar por WhatsApp" data-id="element-166">
      <MessageCircleIcon className="w-8 h-8" data-id="element-167" />
      <span className="absolute -top-2 -right-2 flex h-4 w-4" data-id="element-168">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-orange opacity-75" data-id="element-169"></span>
        <span className="relative inline-flex rounded-full h-4 w-4 bg-orange" data-id="element-170"></span>
      </span>
    </motion.a>;
}